import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { FEATURE_FLAGS_AND_LIMITS_FEATURE_KEY, featureFlagsAndLimitsReducer } from './data-access/store/reducers';
import { FeatureFlagsAndLimitsEffects } from './data-access/store/effects';
import { TotalDowntimePageComponent } from './ui/total-downtime-page/total-downtime-page.component';
import { IconModule } from '@backbase/ui-ang/icon';
import { CollapsibleModule } from '@backbase/ui-ang/collapsible';
import { ButtonModule } from '@backbase/ui-ang/button';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(FEATURE_FLAGS_AND_LIMITS_FEATURE_KEY, featureFlagsAndLimitsReducer),
    EffectsModule.forFeature([FeatureFlagsAndLimitsEffects]),
    IconModule,
    CollapsibleModule,
    ButtonModule
  ],
  declarations: [TotalDowntimePageComponent],
  exports: [TotalDowntimePageComponent]
})
export class SbkFeatureFeatureFlagsAndLimitsModule { }
